import { Orders } from '@mummssoftware/utils/constants';

const IDG_VIEWS = new Set(['IDG', 'IDG Only']);

export const radioOptionsWithoutIdg = (
  options: Record<string, string>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(options).filter(([, value]) => !IDG_VIEWS.has(value)),
  );

export const widgetHasIdgFilter = (options?: Record<string, string>) =>
  !!options && Object.values(options).some((value) => IDG_VIEWS.has(value));

/** Dialog state keeps ProgressNotes as `[primaryView, ordersLayout]`. */
const viewForPreconfig = (view: unknown): string | undefined => {
  if (Array.isArray(view)) return view[0] || Orders;
  return view as string | undefined;
};

const ordersLayoutForPreconfig = (view: unknown): string | undefined =>
  Array.isArray(view) ? view[1] : undefined;

export const mergePreconfigWidgets = (
  loaded: mumms.PrintPreconfig['widgets'],
  visible: mumms.ComponentName[],
  dialog: mumms.PrintWidgetConfigInterface,
): mumms.PrintPreconfig['widgets'] => {
  const merged: mumms.PrintPreconfig['widgets'] = { ...loaded };
  visible.forEach((name) => {
    const val = dialog[name];
    if (!val) {
      delete merged[name];
      return;
    }
    if (val === true) {
      merged[name] = {};
      return;
    }
    const sel = val as mumms.WidgetPrintSelection;
    merged[name] = {
      ...(sel.view != null ? { view: viewForPreconfig(sel.view) } : {}),
      ...(ordersLayoutForPreconfig(sel.view) != null
        ? { ordersLayout: ordersLayoutForPreconfig(sel.view) }
        : {}),
      ...(sel.notesMode != null && sel.notesMode !== 'none'
        ? { notesMode: sel.notesMode }
        : {}),
      ...(sel.filter != null ? { filter: sel.filter } : {}),
    };
  });
  return merged;
};

export const widgetsSnapshotKey = (widgets: mumms.PrintPreconfig['widgets']) =>
  JSON.stringify(
    Object.keys(widgets)
      .sort()
      .map((k) => [k, widgets[k as mumms.ComponentName]]),
  );
